<template>
  <div class="row">
    <div class="col-6">
      <vi-card border>
        <template v-slot:title>
          <div class="row align-items-center">
            <div class="icon-box icon-box-warning">
              <vi-icon name="fas:dollar-sign"></vi-icon>
            </div>
            <span class="ml-4 font-weight-bolder">余额钱包</span>
          </div>
        </template>
        <template v-slot:toolbar>
          <div class="text-cursor" @click="eSync('1')">
            <vi-icon name="fas:sync"></vi-icon>
          </div>
        </template>
        <div class="menu_table">
          <table class="table table-vertical-center">
            <thead>
              <tr>
                <th scope="col">币种</th>
                <th scope="col">余额</th>
                <th scope="col">开通状态</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in debitCurrencyList" :key="index">
                <td class="row align-items-center">
                  <div
                    class="currency_code align-items-center font-weight-bolder"
                  >
                    <span>{{ item.code }}</span>
                  </div>
                  <span class="ml-3 font-weight-bolder">{{ item.name }}</span>
                </td>
                <td>
                  <span
                    class="text-success"
                    :class="item.balance > 0 ? 'text-succes' : 'text-danger'"
                  >
                    <span class="p-1"> {{ item.prefix }}</span>
                    <vi-amount v-model="item.balance" />
                  </span>
                </td>
                <td>
                  <span v-if="item.switchStatus === 'On'" class="text-success">
                    已开通
                  </span>
                  <span v-else class="text-danger text-cursor">未开通</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </vi-card>
    </div>
    <div class="col-6">
      <vi-card border>
        <template v-slot:title>
          <div class="row align-items-center">
            <div class="icon-box icon-box-success">
              <vi-icon name="fas:credit-card"></vi-icon>
            </div>
            <span class="ml-4 font-weight-bolder">信用钱包</span>
          </div>
        </template>
        <template v-slot:toolbar>
          <div class="text-cursor" @click="eSync('2')">
            <vi-icon name="fas:sync"></vi-icon>
          </div>
        </template>
        <table class="table table-head-custom table-vertical-center">
          <thead>
            <tr>
              <th scope="col">币种</th>
              <th scope="col">额度</th>
              <th scope="col">可用额度</th>
              <th scope="col">开通状态</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in creditCurrencyList" :key="index">
              <td class="row align-items-center">
                <div
                  class="currency_code align-items-center font-weight-bolder"
                >
                  <span>{{ item.code }}</span>
                </div>
                <span class="ml-3 font-weight-bolder">{{ item.name }}</span>
              </td>
              <td>
                <span class="p-1"> {{ item.prefix }}</span>
                <vi-amount v-model="item.credit" />
              </td>
              <td>
                <span
                  class="text-success"
                  :class="item.balance > 0 ? 'text-succes' : 'text-danger'"
                >
                  <span class="p-1"> {{ item.prefix }}</span>
                  <vi-amount v-model="item.balance" />
                </span>
              </td>
              <td>
                 <span v-if="item.switchStatus === 'On'" class="text-success">
                    已开通
                  </span>
                  <span v-else class="text-danger text-cursor">未开通</span>
              </td>
            </tr>
          </tbody>
        </table>
      </vi-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerAccountBalanceCtrl",
  data() {
    return {
      debitCurrencyList: [],
      debitList: [],
      creditList: [],
      currencyList: [],
      creditCurrencyList: [],
    };
  },
  mounted() {
    this.eGetCurrencyList();
    this.eGetUserWalletList();
  },
  watch: {},
  methods: {
    eGetUserWalletList() {
      this.debitList = [];
      this.creditList = [];
      this.$$.api.data
        .list("/kernel/enterprise/apis/data/customerWallet", {
          columns: ["*", "wallet.*"],
          requirement: {
            filters: [
              {
                Name: "CustomerSN",
                Type: "Equal",
                Value: this.$route.params.sn,
              },
            ],
          },
        })
        .then((res) => {
          let data = res.data.list;
          data.map((p) => {
            if (p.wallet.type === "Debit") {
              this.debitList.push(p);
            }
            if (p.wallet.type === "Credit") {
              this.creditList.push(p);
            }
          });
          this.debitCurrencyList.map((p) => {
            this.debitList.map((m) => {
              if (m.wallet.currencySN === p.sn) {
                p["balance"] = m.wallet.balance;
                p["switchStatus"] = "On";
                p["walletSN"] = m.walletSN;
              }
            });
          });
          this.creditCurrencyList.map((p) => {
            this.creditList.map((m) => {
              if (m.wallet.currencySN === p.sn) {
                p["balance"] = m.wallet.balance;
                p["switchStatus"] = "On";
                p["walletSN"] = m.walletSN;
                p["credit"] = m.wallet.credit;
              }
            });
          });
        });
    },
    eGetCurrencyInfo() {
      let result = new Promise((resolve, reject) => {
        this.$$.api.data
          .list("/kernel/transaction/apis/data/currency", {})
          .then((res) => {
            let data = res.data.list;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            this.$$.toastr.error(err.message);
          });
      });
      return result;
    },
    eGetCurrencyList(status) {
      if (status && status == "1") {
        this.debitCurrencyList = [];
        this.eGetCurrencyInfo().then((data) => {
          data.map((p) => {
            p["balance"] = 0;
            p["switchStatus"] = "Off";
            p["walletSN"] = "";
            p["credit"] = "0";
            this.debitCurrencyList.push({ ...p });
          });
        });
      } else if (status && status == "2") {
        this.creditCurrencyList = [];
        this.eGetCurrencyInfo().then((data) => {
          data.map((p) => {
            p["balance"] = 0;
            p["switchStatus"] = "Off";
            p["walletSN"] = "";
            p["credit"] = "0";
            this.creditCurrencyList.push({ ...p });
          });
        });
      } else {
        this.debitCurrencyList = [];
        this.creditCurrencyList = [];
        this.$$.api.data
          .list("/kernel/transaction/apis/data/currency", {})
          .then((res) => {
            let data = res.data.list;
            if (data) {
              data.map((p) => {
                p["balance"] = 0;
                p["switchStatus"] = "Off";
                p["walletSN"] = "";
                p["credit"] = "0";
                this.debitCurrencyList.push({ ...p });
                this.creditCurrencyList.push({ ...p });
              });
            }
          });
      }
    },
    eSync(status) {
      this.eGetCurrencyList(status);
      this.eGetUserWalletList();
    },
  },
};
</script>

<style lang="scss" scoped>
.currency_code {
  display: inline-block;
  padding: 11px;
  background: #bbbbbb;
  text-align: center;
  border-radius: 5px;
}
.text-cursor {
  cursor: pointer;
}
.icon-box {
  width: 48px;
  height: 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  i {
    color: #fff;
    font-size: 25px;
  }
}
.icon-box-warning {
  background: #ffa800;
}
.icon-box-success {
  background: #1bc5bd;
}
.table thead th {
  border-bottom: none;
}
</style>